// @flow strict

/* eslint-disable ta-code-conventions/has-matching-storydoc, ta-code-conventions/has-matching-test */
import * as React from 'react';

type Props = {|
  /** callback for when the user has given the permission */
  hasPermission: () => ?React.Node,

  /** callback for when the user has denied permission */
  deniedPermission: () => ?React.Node,

  /** callback for when the user has never been prompted for location permission. */
  promptPermission: () => ?React.Node,

  /** callback for when the location positioning is not turned on */
  positioningOff: () => ?React.Node,
|};

type State = {|
  outputComponent: ?React.Node,
|};

/**
 * Check if the user has given us the geolocation permission
 */
class HasLocationPermission extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      outputComponent: null,
    };
  }

  componentDidMount() {
    if (navigator && navigator.permissions && navigator.permissions.query) {
      navigator.permissions.query({ name: 'geolocation' }).then(status => {
        if (status && status.state) {
          // permission granted
          if (status.state === 'granted') {
            navigator.geolocation.getCurrentPosition(
              // successfully get position
              () => {
                this.setState({ outputComponent: this.props.hasPermission() });
              },
              // error
              error => {
                // the location positioning is not turned on
                if (error.code === error.POSITION_UNAVAILABLE) {
                  this.setState({ outputComponent: this.props.positioningOff() });
                }
              },
            );
          } else if (status.state === 'denied') {
            this.setState({ outputComponent: this.props.deniedPermission() });
          } else if (status.state === 'prompt') {
            this.setState({ outputComponent: this.props.promptPermission() });
          }
        }
      });
    }
  }

  render() {
    return <React.Fragment>{this.state.outputComponent}</React.Fragment>;
  }
}

export default HasLocationPermission;
